import React from "react"; 
import OrderRouteListPageContainer from "./OrderRouteListPageContainer";

export class OrderRouteListPage extends React.Component {
  render() {
    return <OrderRouteListPageContainer {...this.props} />;
  }
}
